import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class SistemaGestaoService {
    private urlModulo = `${environment.urlAPI}/sistemagestao`;

    constructor(private http: HttpClient) { }

    /**
     * Recupera Lista de Sistemas De gestao
     */
    public getListaSistemaGestao(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-lista`)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.sistemasGestao);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter lista de sistemas de gestão:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera Lista de Arquivos de Norma
     */
    public getListaArquivoNorma(sigla: string): Promise<any> {
        const params = new HttpParams().set('sigla', sigla);
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-listaNormaArquivo`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.sistemasGestao);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter arquivos de norma:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera o Sistema de Gestão
     * @param codigo do fornecedor para recuperar as informações do arquivo de certificado
     */
    public getSistemaGestaoById(codigo: string): Promise<any> {
        const params = new HttpParams().set('codigo', codigo);
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-byid`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.sistemasGestao);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter sistema de gestão por ID:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera Lista de Sistemas De gestaoFase1
     */
    public getListaSistemaGestaoFase1(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-listaArquivo`)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.sistemasGestaoFase1);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter lista de sistemas de gestão fase 1:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Deleta arquivo de norma
     */
    public deletarArquivoNorma(codigo: string): Promise<any> {
        const params = new HttpParams().set('codigo', codigo);
        
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.urlModulo}-arquivoNormaDeletar`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao deletar arquivo de norma:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Grava o sistema de gestão
     */
    public gravaSistemaGestao(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-salvar`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao gravar sistema de gestão:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Grava o arquivo no sistema - fase 1
     */
    public gravaSistemaGestaoFase1(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-salvarfase1`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao gravar sistema de gestão fase 1:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Inativa o Sistema Gestao
     */
    public inativarSistemaGestao(codigo: string, inativo: boolean): Promise<any> {
        const payload = { codigo, inativo };
        
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-inativar`, payload)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao inativar sistema de gestão:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Grava os Requisitos de Sistema Gestao Fase 2
     */
    public gravaSistemaGestaoFase2(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-salvarfase2`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao gravar sistema de gestão fase 2:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera os Requisitos de Sistema Gestao Fase 2
     */
    public getSistemaGestaoFase2(codSistemaGestao: string): Promise<any> {
        const params = new HttpParams().set('codSistemaGestao', codSistemaGestao);
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-getfase2`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.sistemasGestaoFase2);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter sistema de gestão fase 2:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Atualiza a ordem dos Requisitos de Sistema Gestao Fase 2
     */
    public atualizaOrdemSistemaGestaoFase2(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-atualizaordem`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao atualizar ordem do sistema de gestão fase 2:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera os itens de checklist para auditoria: se já foram marcados anteriormente ou não
     */
    public getItensChecklistProgramacaoAuditoria(codSistemaGestao: any, codAuditoria: any): Promise<any> {
        const params = new HttpParams()
            .set('codAuditoria', codAuditoria)
            .set('codSistemaGestao', codSistemaGestao);
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-recuperarItensChecklistProgramacaoAuditoria`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.checklist);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter itens de checklist para programação de auditoria:');
                        reject(error);
                    }
                });
        });
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/sistemagestao.service.ts